// extracted by mini-css-extract-plugin
module.exports = {"logoutBtn":"UserLogout_logoutBtn__2jG27","textBtn":"UserLogout_textBtn__1F8jd","btnLogout":"UserLogout_btnLogout__1ZQVt","iconLogout":"UserLogout_iconLogout__3qAMZ"};